import * as R from 'ramda'

import { SET_ENTITIES, SET_EMAIL_SUBSCRIPTION } from 'actions'

const initialState = {
  allIds: [],
  entities: {},
}

const emailSubscription = (state = initialState, action) => {
  const { allIds, entities } = state
  switch (action.type) {
    case SET_ENTITIES:
      return {
        allIds: R.union(allIds, action.allIds.emailSubscription),
        entities: R.merge(entities, action.entities.emailSubscription),
      }
    case SET_EMAIL_SUBSCRIPTION:
      return {
        allIds: R.union(allIds, [action.emailSubscription.id]),
        entities: R.mergeDeepRight(entities, {
          [action.emailSubscription.id]: action.emailSubscription,
        }),
      }
    default:
      return state
  }
}

export default emailSubscription

export const getNotificationFrequency = (state) => {
  const emailSubscriptionId = R.head(state.allIds)
  return R.path([emailSubscriptionId, 'notification_frequency'], state.entities)
}

export const getEmailSubscriptionId = (state) => R.head(state.allIds)

export const getEmailSurveySubscriptionIds = (state) => {
  const emailSubscriptionId = R.head(state.allIds)
  return R.path([emailSubscriptionId, 'email_survey_subscriptions'], state.entities)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/emailSubscription.js